<template>
  <div ref="container">
    <Input.Group compact class="!flex">
      <Input v-bind="getBindValue" v-model:value="state" />
      <MButton
        v-if="modalConfig"
        class="!px-8px"
        v-bind="buttonProps"
        :disabled="disabled"
        style="height: 30px"
        @click.stop="_showModal"
      >
        {{ t(buttonProps?.text || 'c.25090206') }}
      </MButton>
    </Input.Group>

    <Form.ItemRest>
      <BasePageModal @register="registerModal" @ok="onOk" />
    </Form.ItemRest>
  </div>
</template>

<script lang="ts" setup>
  import { Form, Input } from 'ant-design-vue';
  import { computed, ref, useAttrs, watch } from 'vue';
  import type { PageModal } from '@mts/render';
  import { useRuleFormItem } from '@mts-fe/hooks';
  import { omit } from '@mts-fe/utils';
  import { MButtonProps } from '@mts/components/Button';
  import { t } from '@mts/hooks/web/useI18n';
  import BasePageModal from '@mts/render/components/BasePageModal.vue';
  import { usePageModal } from '@mts/render/hooks/usePageModal';

  defineOptions({ name: 'InputCode', inheritAttrs: false });

  const props = withDefaults(
    defineProps<{
      value?: string | number;
      readonly?: boolean;
      disabled?: boolean;
      buttonProps?: MButtonProps;
      allowClear?: boolean;
      modalConfig?: PageModal;
      modalRecord?: Recordable;
    }>(),
    { allowClear: true, modalRecord: () => ({}) },
  );
  const attrs = useAttrs();
  const getBindValue = computed(() => {
    return {
      ...attrs,
      ...omit(props, ['buttonProps', 'modalConfig']),
    };
  });

  const emitData = ref<any[]>([]);
  // Embedded in the form, just use the hook binding to perform form verification
  const [state] = useRuleFormItem(props, 'value', 'change', emitData);

  const emit = defineEmits(['change', 'update:value']);
  watch(
    () => state.value,
    (v) => {
      emit('update:value', v);
    },
  );

  const [registerModal, { showModal }] = usePageModal('InputCode');
  const _showModal = () =>
    props.modalConfig
      ? showModal({}, props.modalRecord, props.modalConfig)
      : console.error('modalConfig is not available', props.modalConfig);

  const onOk = (data: string) => {
    state.value = data;
    emitData.value = [data];
  };
</script>
